import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConsentForms } from '../../pages/client-consent-forms/client-consent-forms.component';
import { url_servicios } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class ClientConsentFormsService {
  private headers = new HttpHeaders().set('ngrok-skip-browser-warning', 'true');
  private http = inject(HttpClient);

  private api<T>(method: string, endpoint: string, data?: unknown): Observable<T> {
    const url = `${url_servicios}/${endpoint}`;
    const options = { headers: this.headers };

    switch (method.toLowerCase()) {
      case 'get':
        return this.http.get<T>(url, options);
      case 'post':
        return this.http.post<T>(url, data, options);
      case 'put':
        return this.http.put<T>(url, data, options);
      case 'delete':
        return this.http.delete<T>(url, options);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }

  storeClientConsents(data: ConsentForms): Observable<unknown> {
    return this.api('post', 'v2/store-client-consents', data);
  }

  getClientConsents(patient: string): Observable<unknown> {
    return this.api('get', `v2/get-client-consents/${patient}`);
  }

  getClientConsentSections(): Observable<unknown> {
    return this.api('get', 'v2/get-client-consents-sections');
  }

  generateClientConsentPdf(patientId: string, sections: number[], isPrint = false): Observable<Blob> {
  return this.http.post(`${url_servicios}/v2/get-client-consent-pdf/${patientId}`, { sections, isPrint }, {
    responseType: 'blob'
  });
}
}
